import { t } from '@/i18n/utils'

/**
 * Ranking 页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const rankingCommonConfig = {
  texts: {
    get noMore() { return `${t('NoMore')} ~` },
    get loading() { return `${t('Loading')}...` },
  },
}
